// @flow

import styled from 'styled-components';

export const UnderLabel = styled.p`
  color: ${props => props.theme.colors.gray(60)};
  font-size: small;
`;
